export default class EstornarItemAdesaoInput {
	constructor(itensAdesao = [], justificativa = '', quantidadeEstorno, idAdesao, cancelarDocumentosJuntados) {
		this.itensAdesao = itensAdesao
		this.justificativa = justificativa
		this.quantidadeEstorno = quantidadeEstorno
		this.idAdesao = idAdesao
		this.cancelarDocumentosJuntados = cancelarDocumentosJuntados
	}
}
